<div class="relative max-h-65vh overflow-auto">
  <ng-content></ng-content>
</div>
